import { render } from "./SyncInfoBanner.vue?vue&type=template&id=5a22af08&ts=true"
import script from "./SyncInfoBanner.vue?vue&type=script&lang=ts"
export * from "./SyncInfoBanner.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__